// extracted by mini-css-extract-plugin
export default {"colorText":"k--z","colorTextLabel":"l--z","colorTextValue":"m--z","fieldset":"n--z","swatches":"o--z","collapseLink":"p--z","isCollapsed":"q--z","dropdown":"r--z","disabled":"s--z"};